/* eslint-disable no-param-reassign */
import { MiTHEME } from "@miplatform/theme";
import { clamp } from "../clamp/clamp";

function hexToRgb(color) {
  color = color.substr(1);

  const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
  let colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map((n) => n + n);
  }

  return colors
    ? `rgb${colors.length === 4 ? "a" : ""}(${colors
        .map((n, index) =>
          index < 3
            ? parseInt(n, 16)
            : Math.round((parseInt(n, 16) / 255) * 1000) / 1000
        )
        .join(", ")})`
    : "";
}
function decomposeColor(color) {
  if (color?.type) {
    return color;
  }

  if (color.charAt(0) === "#") {
    return decomposeColor(hexToRgb(color));
  }

  const marker = color.indexOf("(");
  const type = color.substring(0, marker);

  if (["rgb", "rgba", "hsl", "hsla"].indexOf(type) === -1) {
    throw new Error("Unsupported color type.\n", color);
  }

  let values = color.substring(marker + 1, color.length - 1).split(",");
  values = values.map((value) => parseFloat(value));

  return { type, values };
}

function recomposeColor(color) {
  const { type } = color;
  let { values } = color;

  if (type.indexOf("rgb") !== -1) {
    values = values.map((n, i) => (i < 3 ? parseInt(n, 10) : n));
  } else if (type.indexOf("hsl") !== -1) {
    values[1] = `${values[1]}%`;
    values[2] = `${values[2]}%`;
  }

  return `${type}(${values.join(", ")})`;
}

const getLuminance = (r, g, b) => {
  const a = [r, g, b].map((v) => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  });
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
};

export const alphaColor = (color, value) => {
  if (!color) {
    return color;
  }

  color = decomposeColor(color);
  value = clamp(value);

  if (color?.type === "rgb" || color?.type === "hsl") {
    color.type += "a";
  }
  color.values[3] = value;

  return recomposeColor(color);
};

export const getContrastColor = (hexColor = "") => {
  const bigint = parseInt(hexColor.replace(/^#/, ""), 16);

  // eslint-disable-next-line no-bitwise
  const [r, g, b] = [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
  const luminance = getLuminance(r, g, b);
  return luminance > 0.5
    ? MiTHEME.palette.common.black
    : MiTHEME.palette.common.white;
};

export const addAlpha = (color, alpha) => {
  return color + alpha;
};
